import { Box, Typography } from '@mui/material'
import RequiredLabel from './RequiredLabel'
import styled from '@emotion/styled'

const RootBox = styled(Box)({
    background: '#fbfbfd',
    margin: '0',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.6rem',
})

const Header = styled(Box)(({ hideShadow }) => ({
    gap: '1.5rem',
    display: 'flex',
    position: 'relative',
    padding: '1.25rem 3rem 1.5rem',
    background: '#fbfbfd',

    ...(!hideShadow && {
        '&::after': {
            content: '""',
            position: 'absolute',
            inset: 'auto 0 -1.6rem 0',
            zIndex: 1,
            height: '1.6rem',
            background:
                'linear-gradient(180deg, rgba(0,0,0,0.05), rgba(0,0,0,0))',
        },
    }),

    '& h3': {
        fontSize: '1.6rem',
        fontWeight: '600',
        width: '23.2rem',
        color: '#1b1f1f',
    },
}))

const FieldItemWrapper = ({
    title,
    fieldTypeScope,
    headerStyle,
    isRequired,
    childStyle,
    children,
    hideShadow,
}) => {
    return (
        <RootBox>
            <Box>
                <Header sx={headerStyle} hideShadow={hideShadow}>
                    <Box>
                        <Typography variant="h3">
                            {title}{' '}
                            {fieldTypeScope && (
                                <span>({fieldTypeScope || '-'})</span>
                            )}
                        </Typography>
                        {isRequired && <RequiredLabel />}
                    </Box>
                    <Box sx={childStyle}>{children}</Box>
                </Header>
            </Box>
        </RootBox>
    )
}

export default FieldItemWrapper
